import { useMemo, useState } from "react";

import { Autocomplete } from "@aclymatepackages/atoms";
import { currencies } from "@aclymatepackages/lists";

const Currencies = ({
  multiple = false,
  setValue,
  value,
  size,
  ...otherProps
}) => {
  const [inputValue, setInputValue] = useState("");

  // Build options with guaranteed id and name, and sort by name
  const options = useMemo(() => {
    return (currencies || [])
      .map((currency) => ({
        id: currency.id ?? String(currency.label ?? currency),
        name: currency.label ?? String(currency.id ?? currency),
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, []);

  const renderOption = (props, option) => {
    return (
      <li {...props} key={option.id}>
        {option?.name} ({option?.id})
      </li>
    );
  };

  // Map incoming value (id or array of ids) to option object(s) expected by Autocomplete
  const selectedValue = multiple
    ? Array.isArray(value)
      ? options.filter((o) => value.includes(o.id))
      : []
    : options.find((o) => o.id === value) || null;

  const handleChange = (event, newValue) => {
    if (multiple) {
      const ids = Array.isArray(newValue) ? newValue.map((v) => v.id) : [];
      return setValue(ids);
    }

    return setValue(newValue ? newValue.id : null);
  };

  return (
    <Autocomplete
      label="Select Currency"
      availableOptions={options}
      multiple={multiple}
      renderOption={renderOption}
      inputValue={inputValue}
      onInputChange={(e, newInputValue) => setInputValue(newInputValue)}
      value={selectedValue}
      onChange={handleChange}
      size={size}
      {...otherProps}
    />
  );
};

export default Currencies;
